export default (str) => {
  return str ? str.replaceAll('\n', '<br>').replaceAll('\t', '&nbsp;&nbsp;') : null
}
